(() => {
  const initSlider = (slider) => {
    if (slider.dataset.sliderReady === 'true') return;

    const track = slider.querySelector('.brand-home__slider-track');
    const slides = Array.from(slider.querySelectorAll('[data-domain-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-slider-dot]'));
    const previous = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    const delay = Number(slider.dataset.autoplay || 5500);
    let index = 0;
    let timer;

    if (!track || slides.length < 2) {
      slider.classList.add('brand-home__slider--static');
      return;
    }

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = undefined;
    };

    const goTo = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.tabIndex = active ? 0 : -1;
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const start = () => {
      stop();
      timer = window.setInterval(() => goTo(index + 1), delay);
    };

    previous?.addEventListener('click', () => {
      goTo(index - 1);
      start();
    });

    next?.addEventListener('click', () => {
      goTo(index + 1);
      start();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(Number(dot.dataset.sliderDot));
        start();
      });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    slider.dataset.sliderReady = 'true';
    goTo(0);
    start();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-domain-slider]').forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
